import type { PdfComponent } from '../../TermsAndConditionsRender/components/typed';

export const SECTION35: PdfComponent = {
  type: 'section',
  id: 's35',
  title: '35. Third Party Rights',
  content: [
    {
      type: 'bulletList',
      id: 's35bullets',
      bulletType: 'number',
      content: [
        {
          copy: 'Except as expressly provided in this Agreement, a person who is not a party to this Agreement shall not have any rights under the Contracts (Rights of Third Parties) Act 1999 to enforce any of its provisions.',
        },
        {
          copy: 'The rights of the parties to terminate, rescind or agree any variation, waiver or settlement under this Agreement are not subject to the consent of any person not party to this Agreement.',
        },
      ],
      prefix: '35',
    },
  ],
};
